$('.faq__question__icon').click(function () {
  var curFaq = $(this).parents('.faq');
  if (curFaq.hasClass('faq_active')) {
    curFaq.removeClass('faq_active');
    return;
  }
  $(this).parents('.faqs').find('.faq_active').removeClass('faq_active');
  curFaq.addClass('faq_active');
});



// WEBPACK FOOTER //
// ./scripts/blocks/faq.js